exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "device-assignment .ui-growl {\n  z-index: 1035 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/device-assignment/device-assignment.component.scss
// module id = ../../../../../src/app/component-module/device-assignment/device-assignment.component.scss
// module chunks = main